/* Mystery Pair add-on: own card, own state, and it puts its own line in the
   cart by intercepting the Add to Cart click (adds itself first, then lets the
   page's own handler add the trunks and open the drawer).
   $22.99 is deliberate: 1 pair + mystery = $52.98, a cent above the 2-pack,
   so this can never undercut the bundle. */
(function(){
var VAR={S:54509942899027,M:54509942931795,L:54509942964563,XL:54509942997331,'2XL':54509943030099,'3XL':54509943062867,'4XL':54509943095635};
var SIZES=['S','M','L','XL','2XL','3XL','4XL'];
var PRICE=22.99;
var IMG='https://cdn.shopify.com/s/files/1/1021/7298/3635/files/mystery-pair-v2.webp';
var st={on:false,size:'L'};
var totalLine;
var passthrough=false;

window.CD_EXTRA_ITEMS=function(){
if(!st.on)return [];
var id=VAR[st.size];
return id?[{id:id,quantity:1}]:[];
};

function el(t,s,h){var e=document.createElement(t);if(s)e.setAttribute('style',s);if(h!==undefined)e.innerHTML=h;return e;}

function syncTotal(){
if(!totalLine)return;
var base=parseFloat((document.getElementById('cd-total')||{}).innerHTML)||0;
if(!st.on||!base){totalLine.style.display='none';return;}
totalLine.style.display='block';
totalLine.innerHTML='Trunks $'+base.toFixed(2)+' &nbsp;+&nbsp; Mystery Pair $'+PRICE.toFixed(2)+' &nbsp;=&nbsp; <strong>$'+(base+PRICE).toFixed(2)+'</strong>';
}

function build(){
var addBtn=document.getElementById('cd-add');
if(!addBtn||document.getElementById('cd-mystery'))return false;

var card=el('div','border:2px dashed #c9a227; background:#fffdf5; border-radius:16px; padding:14px; margin-bottom:18px;');
card.id='cd-mystery';

var head=el('label','display:flex; align-items:flex-start; gap:12px; cursor:pointer;');
var box=document.createElement('input');
box.type='checkbox';
box.setAttribute('style','width:22px; height:22px; margin:2px 0 0; accent-color:#b1272f; flex-shrink:0; cursor:pointer;');

var thumb=el('img','width:52px; height:52px; border-radius:10px; object-fit:cover; background:#0d2340; flex-shrink:0;');
thumb.src=IMG;
thumb.alt='The Mystery Pair';

var copy=el('div','flex:1; min-width:0;',
'<div style="display:flex; align-items:center; gap:8px; flex-wrap:wrap; margin-bottom:2px;">'+
'<span style="font-family:Anton, sans-serif; font-size:17px; color:#0d2340; letter-spacing:0.3px;">ADD THE MYSTERY PAIR</span>'+
'<span style="background:#c9a227; color:#0d2340; font-size:10px; font-weight:800; padding:3px 8px; border-radius:999px; white-space:nowrap;">SAVE $7</span>'+
'</div>'+
'<div style="font-size:13px; color:#5a6178; line-height:1.45;">One of our 5 best-selling styles. We pick, you panic — hate it and we swap it free. <strong style="color:#0d2340;">$22.99</strong> <span style="text-decoration:line-through; color:#9aa2b3;">$29.99</span></div>');

head.appendChild(box);
head.appendChild(thumb);
head.appendChild(copy);
card.appendChild(head);

var sizeWrap=el('div','display:none; margin-top:12px; padding-top:12px; border-top:1px solid #eee4c9;');
sizeWrap.appendChild(el('div','font-size:11px; font-weight:700; color:#8a8f9f; margin-bottom:6px;','MYSTERY PAIR SIZE'));
var srow=el('div','display:flex; gap:6px; flex-wrap:wrap;');
sizeWrap.appendChild(srow);
card.appendChild(sizeWrap);

function drawSizes(){
srow.innerHTML='';
SIZES.forEach(function(s){
var on=s===st.size;
var b=el('button','min-width:42px; padding:8px 6px; border-radius:8px; font-weight:700; font-size:12px; cursor:pointer; border:2px solid '+(on?'#0d2340':'#e5e0d3')+'; background:'+(on?'#0d2340':'#fff')+'; color:'+(on?'#fff':'#0d2340')+';',s);
b.type='button';
b.onclick=function(){st.size=s;drawSizes();};
srow.appendChild(b);
});
}
drawSizes();

box.onchange=function(){
st.on=box.checked;
sizeWrap.style.display=st.on?'block':'none';
card.style.borderStyle=st.on?'solid':'dashed';
card.style.background=st.on?'#fdf6e3':'#fffdf5';
syncTotal();
};

addBtn.parentNode.insertBefore(card,addBtn);

totalLine=el('div','display:none; margin-top:10px; text-align:center; font-size:13px; color:#5a6178;');
addBtn.parentNode.insertBefore(totalLine,addBtn.nextSibling);

var t=document.getElementById('cd-total');
if(t&&window.MutationObserver){new MutationObserver(syncTotal).observe(t,{childList:true,characterData:true,subtree:true});}

addBtn.addEventListener('click',function(ev){
if(passthrough||!st.on)return;
var id=VAR[st.size];
if(!id)return;
ev.preventDefault();
ev.stopImmediatePropagation();
var label=addBtn.innerHTML;
addBtn.disabled=true;
addBtn.innerHTML='Adding&hellip;';
fetch('/cart/add.js',{method:'POST',credentials:'same-origin',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({items:[{id:id,quantity:1}]})})
.then(function(r){if(!r.ok)throw new Error('rejected');return r.json();})
.then(function(){
addBtn.disabled=false;
addBtn.innerHTML=label;
passthrough=true;
addBtn.click();
passthrough=false;
})
.catch(function(){
addBtn.disabled=false;
addBtn.innerHTML=label;
var e=document.getElementById('cd-err');
if(e){e.innerHTML='Could not add the Mystery Pair. Try again.';e.style.display='block';}
});
},true);

return true;
}

var tries=0;
var iv=setInterval(function(){tries++;if(build()||tries>60)clearInterval(iv);},80);
if(document.readyState!=='loading')build();else document.addEventListener('DOMContentLoaded',build);
})();
